<script setup lang="ts">
import { useAttrs } from 'vue';
import Icon from '../icon/Icon.vue';

export interface topBarProps {
  title?: string;
  centreTitle?: boolean;
  transparent?: boolean;
  showBack?: boolean;
  showImage?: boolean;
  img?: string;
  imgClass?: string;
  heightClass?: string;
}

withDefaults(defineProps<topBarProps>(), {
  centreTitle: false,
  transparent: false,
  showBack: false,
  heightClass: 'h-14',
});

defineEmits<{
  back: [];
}>();

const attrs = useAttrs();
</script>

<template>
  <div class="relative">
    <div :class="attrs.class" style="padding-top: var(--safe-area-top)" aria-hidden="true">
      <div :class="heightClass"></div>
    </div>
    <header
      class="absolute top-0 left-0 z-50 w-full max-lg:fixed max-lg:inset-x-0"
      :class="attrs.class"
      style="padding-top: var(--safe-area-top)"
    >
      <div :class="['flex items-center px-5 justify-between mx-auto', heightClass]">
        <div class="w-1/5 shrink-0 flex items-center justify-start overflow-hidden">
          <slot name="leading">
            <button
              v-if="showBack"
              class="flex items-center justify-center"
              aria-label="Back"
              @click="$emit('back')"
            >
              <Icon name="arrowLeft" size="md" />
            </button>
          </slot>
        </div>
        <div class="w-3/5 shrink-0 min-w-0 flex items-center justify-center overflow-hidden">
          <slot name="center">
            <img v-if="showImage" :src="img" alt="" :class="imgClass" />
            <h1
              v-else
              :class="[
                'flex-1 truncate text-center text-body font-semibold',
                centreTitle && 'text-center',
              ]"
            >
              {{ title }}
            </h1>
          </slot>
        </div>
        <div class="w-1/5 shrink-0 flex items-center justify-end overflow-hidden">
          <slot name="trailing" />
        </div>
      </div>
    </header>
  </div>
</template>
